import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M15.5 10.938H8.5C8.225 10.938 8 10.713 8 10.438C8 10.163 8.225 9.93799 8.5 9.93799H15.5C15.775 9.93799 16 10.163 16 10.438C16 10.713 15.775 10.938 15.5 10.938Z"
      fill="currentColor"
    />
    <path
      d="M16 13.438C16 13.713 15.775 13.938 15.5 13.938H8.5C8.225 13.938 8 13.713 8 13.438C8 13.163 8.225 12.938 8.5 12.938H15.5C15.775 12.938 16 13.163 16 13.438Z"
      fill="currentColor"
    />
    <path
      d="M15.5 16.938H8.5C8.225 16.938 8 16.713 8 16.438C8 16.163 8.225 15.938 8.5 15.938H15.5C15.775 15.938 16 16.163 16 16.438C16 16.713 15.775 16.938 15.5 16.938Z"
      fill="currentColor"
    />
    <path
      d="M17.2691 21.994H6.61912C5.33812 21.994 4.29712 20.95 4.29712 19.669V5.10002C4.29712 3.81902 5.33812 2.77502 6.61912 2.77502H7.76312C8.04112 2.77502 8.26912 3.00002 8.26912 3.28102C8.26912 3.55902 8.04412 3.78702 7.76312 3.78702H6.61912C5.89712 3.78702 5.31012 4.37402 5.31012 5.10002V19.672C5.31012 20.397 5.89712 20.985 6.61912 20.985H17.2721C17.9911 20.985 18.5781 20.397 18.5781 19.672V5.10002C18.5781 4.37502 17.9941 3.78702 17.2721 3.78702H16.1251C15.8471 3.78702 15.6191 3.56202 15.6191 3.28102C15.6191 3.00302 15.8441 2.77502 16.1251 2.77502H17.2691C18.5471 2.77502 19.5851 3.81902 19.5851 5.10002V19.672C19.5851 20.953 18.5481 21.994 17.2691 21.994V21.994Z"
      fill="currentColor"
    />
    <path
      d="M13.297 6.666H10.588C9.838 6.666 9.229 6.057 9.229 5.303V3.384C9.229 2.634 9.838 2.021 10.588 2.021H13.297C14.047 2.021 14.659 2.63 14.659 3.384V5.303C14.659 6.056 14.047 6.666 13.297 6.666ZM10.588 3.037C10.397 3.037 10.241 3.193 10.241 3.387V5.306C10.241 5.5 10.397 5.656 10.588 5.656H13.297C13.491 5.656 13.647 5.5 13.647 5.306V3.387C13.647 3.193 13.491 3.037 13.297 3.037H10.588Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Contract');

export default Icon;
